module.exports = __webpack_public_path__ + "static/media/Rectangle.018b9bbb.png";